import { lazy } from 'react';
const RecutRebond = lazy(() => import('./RecutRebond'));

const RecutRebondRoutes = [
  {
    path: '/recutrebond',
    component: RecutRebond
  }
];

export default RecutRebondRoutes;
